import { render, staticRenderFns } from "./AdvanceRequisiteRules.vue?vue&type=template&id=70d9e1b0&"
import script from "./AdvanceRequisiteRules.vue?vue&type=script&lang=js&"
export * from "./AdvanceRequisiteRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports